import { HydrationSVG } from "./SVGIllustrations";
import { PillSelect } from "@/components/we360/PillSelect";
import { CalculatedBadge } from "@/components/we360/CalculatedBadge";
import { AlertBanner } from "@/components/we360/AlertBanner";
import { HYDRATION_OPTIONS } from "./helpers";

export default function Step4Hydration({ value, onChange, hydrationCat, errors }) {
  return (
    <div>
      <HydrationSVG />

      <div
        className="rounded-[14px] p-3 mt-3 mb-4 text-xs leading-relaxed"
        style={{ background: "#FCFAEE", border: "1px solid #E2D9CB", color: "#2D2A24" }}
      >
        ¿Cuántos vasos de agua (aproximadamente 250 ml cada uno) tomas al día?
      </div>

      <PillSelect
        label="Vasos de agua al día"
        options={HYDRATION_OPTIONS.map((o) => ({ label: o.label, value: o.value }))}
        value={value}
        onChange={onChange}
        error={errors?.getError("hydration")}
        testId="f4-hydration"
        columns={1}
      />

      {hydrationCat && (
        <CalculatedBadge
          label="Hidratación"
          value={hydrationCat.category}
          categoryColor={hydrationCat.color}
          testId="badge-hidratacion"
        />
      )}

      <AlertBanner variant="info" testId="alert-oms-agua">
        La OMS recomienda un mínimo de 2 litros de agua al día (~8 vasos) para adultos.
      </AlertBanner>
    </div>
  );
}
